import request from '@/utils/request'

export default {
  // 新增修改tips
  addOrEditTips(method,data) {
    return request({
      url:'/system/tips',
      method,
      data
    })
  },
  // 获取或删除新人tips详细信息
  findOrDelTips(method,id) {
    return request({
      url:`/system/tips/${id}`,
      method
    })
  },
  // 查询新人tips列表
  findTipsList() {
    return request({
      url:'/system/tips/list',
      method:'get'
    })
  },
  // 新增修改融入计划
  addOrEditPlan(method,data) {
    return request({
      url:'/system/plan',
      method,
      data
    })
  },
  // 获取或删除融入计划
  findOrDelPlan(method,id) {
    return request({
      url:`/system/plan/${id}`,
      method
    })
  },
  // 查询融入计划列表
  findPlanList() {
    return request({
      url:'/system/plan/list',
      method:'get'
    })
  }
}